/** @jsxImportSource @emotion/react */
import * as s from './style';
import axios from 'axios';
import React, { useEffect, useState } from 'react';
import { API_URL } from 'config/URL/URL';
import SelectMemuItem from '../table_element/SelectMemuItem';

const CategoryMenu = ({ index, selectedCategory, setSelectedCategory }) => {
    const [categoryData, setCategoryData] = useState();
    const [selectedCategoryGroup, setSelectedCategoryGroup] = useState();

    useEffect(() => {
        fetchInit();
    }, []);

    const fetchInit = async () => {
        try {
            const resultArray = await getCategoryData();
            setCategoryData(resultArray);

            const initGroupKey = resultArray[0].categoryCd;
            const initCategoryKey = resultArray[0].categories[5].categoryCd;

            const initCategoryGroup = resultArray.find((categoryGroup) => categoryGroup.categoryCd === initGroupKey);
            const initCategory = initCategoryGroup.categories.find(
                (category) => category.categoryCd === initCategoryKey
            );

            setSelectedCategoryGroup(initCategoryGroup);
            setSelectedCategory(initCategory, index);
        } catch (error) {
            console.error(error);
        }
    };

    const getCategoryData = async () => {
        const response = await axios.get(`${API_URL}/sodamap-api/category`);
        response.data.sort((a, b) => a.nm_kor.localeCompare(b.nm_kor));

        const resultArray = response.data.filter((item) => item.category === 'main');

        resultArray.forEach((group) => {
            const groupItem = response.data.filter(
                (item) => item.categoryCd[0] === group.categoryCd && item.category !== 'main'
            );
            group.categories = groupItem;
        });

        return resultArray;
    };

    const onClickCategoryGroupHandle = (categoryGroup) => {
        setSelectedCategoryGroup(categoryGroup);
    };

    const onClickCategoryHandle = (category) => {
        setSelectedCategory(category, index);
    };

    if (categoryData)
        return (
            <div css={s.mainContainer}>
                <div css={s.col}>
                    <header css={s.header}>분류</header>
                    <div css={s.content}>
                        {categoryData.map((categoryGroup, idx) => (
                            <SelectMemuItem
                                key={idx}
                                isSelected={categoryGroup.categoryCd === selectedCategoryGroup.categoryCd}
                                onClick={() => onClickCategoryGroupHandle(categoryGroup)}
                            >
                                {categoryGroup.nm_kor}
                            </SelectMemuItem>
                        ))}
                    </div>
                </div>

                <div css={s.divider}></div>

                <div css={s.col}>
                    <header css={s.header}>분류별 주제</header>
                    <div css={s.content}>
                        {selectedCategoryGroup.categories.map((category, idx) => (
                            <SelectMemuItem
                                key={idx}
                                isSelected={category.categoryCd === selectedCategory.categoryCd}
                                onClick={() => onClickCategoryHandle(category)}
                            >
                                {category.nm_kor}
                            </SelectMemuItem>
                        ))}
                    </div>
                </div>
            </div>
        );
};

export default CategoryMenu;
